import * as React from "react";
import CustomerContextProvider from "../../customer/CustomerContextProvider/CustomerContextProvider";
import CartContextProvider, {isCart, useUnsafeCartContext} from "../CartContextProvider/CartContextProvider";
import AddToCartButtonPortal from "../AddToCartButton/AddToCartButtonPortal";
import CartIconPortal, {updateUrlParams} from "../CartIcon/CartIconPortal";
import AddToCartModal from "../../lib/ModalWindow/AddToCartModal";
import VoucherAddedModal from "../../lib/ModalWindow/VoucherAddedModal";
import NewsletterOptInOptOutPortal from "../../newsletter/NewsletterOptInOptOutPortal";
import WishlistPortal from "../../wishlist/WishlistPortal";
import WishlistContextProvider from "../../wishlist/WishlistContextProvider/WishlistContextProvider";
import AddToWishlistButtonPortal from "../../wishlist/AddToWishlistButton/AddToWishlistButtonPortal";
import NewsletterRegistration from "../../newsletter/NewsletterRegistration";
import {CustomerAccount} from "../../customer/account/CustomerAccount";
import ProductSeriesPortal from "../../ProductSeries/ProductSeriesPortal";
import ProductListPortal from "../../productList/ProductListPortal";
import BrandOfTheMonthModalPortal from "../../newsletter/BrandOfTheMonthModalPortal/BrandOfTheMonthModalPortal";
import ProductListWishlistButtonsPortal
  from "../../wishlist/ProductListWishlistButtonsPortal/ProductListWishlistButtonsPortal";

export const Cart: React.FC = () => {
  return (
    <React.Suspense fallback={null}>
      <CustomerContextProvider>
        <CartContextProvider>
          <CartIconPortal
            root={document.getElementById("CartIconRoot")}
            targetNode={document.getElementById("CartIcon")}
          />
          <AddToCartButtonPortal
            root={document.getElementById("AddToCartButtonRoot")}
            targetNode={document.querySelector(".product-cart__form")}
          />
          <AddToCartModalWrapper />
          <VoucherAddedModal />
          <WishlistContextProvider>
            <WishlistPortal />
            <AddToWishlistButtonPortal
              root={document.getElementById("AddToWishlistButtonNew")}
              targetNode={document.querySelector(".product-cart__wishlist")}
            />
            <ProductListPortal />
            <ProductListWishlistButtonsPortal />
            <ProductSeriesPortal />
          </WishlistContextProvider>
        </CartContextProvider>
        <NewsletterRegistration />
        <NewsletterOptInOptOutPortal />
        <BrandOfTheMonthModalPortal />
        <CustomerAccount element={document.getElementById("CustomerAccountReact")} />
      </CustomerContextProvider>
    </React.Suspense>
  );
};

const AddToCartModalWrapper: React.FC = () => {
  const context = useUnsafeCartContext();
  if (!context) {
    return null;
  }

  if (context.itemsAdded.length) {
    return (
      <AddToCartModal
        closeFunction={() => {
          context.setItemsAdded([]);
        }}
        toCartFunction={() => {
          if (!isCart(context)) {
            return;
          }
          context.setItemsAdded([]);
          context.setIsCartVisible(true);
          if (!new URLSearchParams(location.search).get("view")) {
            updateUrlParams("cart");
          }
        }}
        isVisible={true}
        itemIds={context.itemsAdded}
      />
    );
  }

  return null;
};
